<!--
 * @LastEditTime: 2020-08-21 10:56:30
 * @Description: 服务总览
 * @Date: 2020-02-27 13:42:36
 * @Author: @虾哔哔
 -->
<template>
  <div class="service-overview">
    <!--  -->
    <div class="header">
    <h3 class="title">{{ $route.meta.title }}</h3>
      <el-date-picker
        class="date"
        v-model="service_time"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="$pickerOptions"
        @change="init()"
        :clearable="false"
      ></el-date-picker>
    </div>
    <!--  -->
    <div class="content">
      <!-- 统计指标 -->
      <Statistical :data="overview" />
      <el-row   class="chart-row"> 
        <el-col :span="16" class="chart">
          <!-- 指标趋势图 -->
          <TrendChart :data="trend"  v-if="trend.length!==0"/>
        </el-col>
        <el-col :span="8" class="rank">
          <!-- 排行榜 -->
          <RankingList :data="ranking" :time="service_time" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Statistical from "./components/Statistical/Statistical";
import TrendChart from "./components/TrendChart/TrendChart";
import RankingList from "./components/RankingList/RankingList";

export default {
  components: {
    Statistical,
    TrendChart,
    RankingList,
  },
  data() {
    return {
      service_time: [new Date(), new Date()],
      overview: {},
      trend: [],
      ranking: {}
    };
  },
  computed: {
    ...mapGetters(["shopId",'collapseSwitch'])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getStatisticalTrend();
      this.getRanking();
    },
    getStatisticalTrend() {
      let params = {
        authority_id: this.shopId,
        start: dayjs(this.service_time[0]).format("YYYY-MM-DD"),
        end: dayjs(this.service_time[1]).format("YYYY-MM-DD")
      };
      this.$store
        .dispatch("ServiceOverview/getStatisticalTrend", params)
        .then(res => {
          console.log(res);
          if (res.data.code === 2000) {
            this.overview = res.data.data.overview;
            this.trend = res.data.data.trend;
          }
        });
    },
    getRanking() {
      let params = {
        authority_id: this.shopId,
        start: dayjs(this.service_time[0]).format("YYYY-MM-DD"),
        end: dayjs(this.service_time[1]).format("YYYY-MM-DD")
      };
      this.$store.dispatch("ServiceOverview/getRanking", params).then(res => {
        console.log(res);
        if (res.data.code === 2000) {
          this.ranking = res.data.data;
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.service-overview {
  .header {
    display: flex;
    align-items: flex-start;
    position: relative;
    height: 28px;
    .title{
      line-height: 20px;
      margin: 0;
      font-size: 20px;
    }
    .date{
      position: absolute;
      right: 0;
    }
    /deep/.el-range-editor{
      width: 15%;
      padding: 3px;
      border: none;
      border-radius: 6px;
      .el-range-input{
        width: 40%;
      }
      .el-range-separator{
        width: 4px;
        padding: 0;
      }
     .el-range__close-icon{
        width: 14px;
        margin-left: 3px;
        padding-top: 2px;
      }
      .el-icon-date{
        width: 14px;
        margin-left: 5px;
      }
    }
  }
  .content {
    .chart-row{
      margin-top: 30px;

    }
    .chart{
      border: 1px solid #F5F6F9;
      border-radius: 10px;
      min-height: 450px;
      background: #fff;
      padding: 0 20px;
    }
    .rank{
      border-radius: 10px;
      padding-left: 20px;
      
    }
  }
}
</style>
